/**
 * Frontend
 */

// html (depends on xml, javascript and css)
import 'codemirror/mode/htmlmixed/htmlmixed'

// css, scss, less
import 'codemirror/mode/css/css'

// javascript, typescript, json, json5, jsonld
import 'codemirror/mode/javascript/javascript'

// jsx, tsx
import 'codemirror/mode/jsx/jsx'

// vue
import 'codemirror/mode/vue/vue'

/**
 * Document
 */

// markdown, md
import 'codemirror/mode/markdown/markdown'
import 'codemirror/mode/gfm/gfm'

/**
 * Setting
 */

// xml, xsl, xsd, svg, rss, wsdl, xsd
import 'codemirror/mode/xml/xml'

// yaml, yml
import 'codemirror/mode/yaml/yaml'
import 'codemirror/mode/yaml-frontmatter/yaml-frontmatter'

// toml
import 'codemirror/mode/toml/toml'

/**
 * Other
 */

// sh, ksh, bash, sh, zsh
import 'codemirror/mode/shell/shell'
